module.exports = __webpack_public_path__ + "img/qce.b3baa4b2.png";